import { defineTextToRender } from './define-text-to-render.js';
import { setFontDetailsToContext } from './set-font-details-to-context.js';
import { HONEYCOMB_DEFAULT_MIN_ELLIPSIZED_TEXT } from '../../../constants.js';
import { CanvasTextAreaProps } from '../../../types/canvas-text-area.js';

export const getTruncationMethod =
  (
    ctx: CanvasRenderingContext2D,
    textArea: CanvasTextAreaProps,
    name: string,
    truncationMode: 'start' | 'middle' | 'end',
    contentType: 'value' | 'label' = 'label',
  ) =>
  () => {
    setFontDetailsToContext(ctx, contentType);
    const minimumNameSizes = ctx.measureText(
      HONEYCOMB_DEFAULT_MIN_ELLIPSIZED_TEXT,
    );
    const ellipsisMinWidth = minimumNameSizes.width;

    return ellipsisMinWidth > textArea.width
      ? ''
      : defineTextToRender(name, truncationMode, textArea, contentType);
  };
